import React, { useState, useEffect } from "react";
import { Box, Button, Typography, Paper, Stack, Chip } from "@mui/material";
import { QueryStatsOutlined, ShowChartOutlined, PaidOutlined } from "@mui/icons-material";

function TermometroFinanceiro() {
  const [activeSymbol, setActiveSymbol] = useState("BMFBOVESPA:WDO1!");

  const renderWidget = (symbol) => {
    const host = document.getElementById("widget-container");
    if (!host) return;

    host.innerHTML = "";

    const wrapper = document.createElement("div");
    wrapper.className = "tradingview-widget-container";
    wrapper.style.width = "100%";
    wrapper.style.height = "100%";

    const widgetInner = document.createElement("div");
    widgetInner.className = "tradingview-widget-container__widget";
    widgetInner.style.width = "100%";
    widgetInner.style.height = "100%";
    wrapper.appendChild(widgetInner);

    const script = document.createElement("script");
    script.src =
      "https://s3.tradingview.com/external-embedding/embed-widget-technical-analysis.js";
    script.async = true;
    script.innerHTML = JSON.stringify({
      interval: "1m",
      width: "100%",
      isTransparent: false,
      height: 450,
      symbol,
      showIntervalTabs: true,
      displayMode: "single",
      locale: "br",
      colorTheme: "dark",
    });
    wrapper.appendChild(script);
    host.appendChild(wrapper);
  };

  useEffect(() => {
    renderWidget(activeSymbol);
  }, [activeSymbol]);

  return (
    <Paper
      sx={{
        p: { xs: 2.2, md: 3 },
        borderRadius: 3,
        background: "rgba(15,22,33,0.94)",
        border: "1px solid rgba(255,255,255,0.1)",
        boxShadow: "0 16px 40px rgba(0,0,0,0.32)",
      }}
    >
      <Chip
        icon={<QueryStatsOutlined />}
        label="Análise técnica em tempo real"
        sx={{
          mb: 1.4,
          color: "#CFE9FF",
          bgcolor: "rgba(73,149,255,0.18)",
          border: "1px solid rgba(73,149,255,0.35)",
          fontWeight: 700,
        }}
      />

      <Typography variant="h5" sx={{ color: "#F4F9FF", fontWeight: 800, mb: 0.6 }}>
        Termômetro Financeiro
      </Typography>
      <Typography sx={{ color: "rgba(231,240,250,0.74)", mb: 2.2 }}>
        Selecione o ativo para visualizar o resumo técnico e apoiar sua leitura de cenário.
      </Typography>

      <Stack direction={{ xs: "column", sm: "row" }} spacing={1.3} sx={{ mb: 2.4 }}>
        <Button
          variant={activeSymbol === "BMFBOVESPA:WDO1!" ? "contained" : "outlined"}
          onClick={() => setActiveSymbol("BMFBOVESPA:WDO1!")}
          startIcon={<PaidOutlined />}
          sx={{
            textTransform: "none",
            fontWeight: 800,
            borderRadius: 2,
            px: 2.2,
            py: 1,
            borderColor: "rgba(101,198,255,0.45)",
            color: activeSymbol === "BMFBOVESPA:WDO1!" ? "#07240F" : "#BFD9FF",
            background:
              activeSymbol === "BMFBOVESPA:WDO1!"
                ? "linear-gradient(90deg, #56C4FF 0%, #8ED7FF 100%)"
                : "transparent",
          }}
        >
          Mini Dólar
        </Button>
        <Button
          variant={activeSymbol === "BMFBOVESPA:WIN1!" ? "contained" : "outlined"}
          onClick={() => setActiveSymbol("BMFBOVESPA:WIN1!")}
          startIcon={<ShowChartOutlined />}
          sx={{
            textTransform: "none",
            fontWeight: 800,
            borderRadius: 2,
            px: 2.2,
            py: 1,
            borderColor: "rgba(126,226,168,0.45)",
            color: activeSymbol === "BMFBOVESPA:WIN1!" ? "#07240F" : "#C9F4D6",
            background:
              activeSymbol === "BMFBOVESPA:WIN1!"
                ? "linear-gradient(90deg, #5FD08C 0%, #8DE3AF 100%)"
                : "transparent",
          }}
        >
          Mini Índice
        </Button>
      </Stack>

      <Box
        sx={{
          position: "relative",
          borderRadius: 2.5,
          overflow: "hidden",
          border: "1px solid rgba(255,255,255,0.1)",
          bgcolor: "#1F1F1F",
          minHeight: 450,
        }}
      >
        <Box
          sx={{
            position: "absolute",
            bottom: 0,
            left: 0,
            width: "100%",
            height: { xs: "40px", sm: "50px" },
            bgcolor: "#1F1F1F",
            zIndex: 10,
          }}
        />

        <Box
          id="widget-container"
          sx={{
            position: "relative",
            width: "100%",
            height: "100%",
          }}
        />
      </Box>
    </Paper>
  );
}

export default TermometroFinanceiro;
